import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=ac8c1bce&scoped=true&"
import script from "./NotificationsView.vue?vue&type=script&lang=js&"
export * from "./NotificationsView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=ac8c1bce&prod&lang=scss&scoped=true&"
import style1 from "./NotificationsView.vue?vue&type=style&index=1&id=ac8c1bce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8c1bce",
  null
  
)

export default component.exports